// extracted by mini-css-extract-plugin
module.exports = {"container":"CardNewChip_container__66F5V","hide":"CardNewChip_hide__mjGWp"};